export default __webpack_public_path__ + "static/media/logo.a41e7d01.png";